import React from 'react';
import ReactDOM from 'react-dom';
import Api from '../../../helpers/api';
import GetBoosts from './GetBoosts';
import { fetchData } from '../../../helpers/base_data_fetcher';
import { getDomainString } from '../../../apps/commerce/checkout/helpers';
import '../../../../sass/pages/my_ads/boost_info.scss';
import '../../../../sass/components/forms.scss';
import '../../../../sass/components/message_box.scss';

export default function get_boosts() {
  const get_boosts_element = document.querySelector('#get-boosts');
  if (get_boosts_element) {
    Promise.all([
      fetchData('site'),
      fetchData('customer'),
      fetchData('affiliate'),
      Api.get(`/web/products?type=upgrade_extra&category=Extra%20Boost`),
      fetchData('localisations'),
    ]).then(([site, customer, affiliate, productResults, localisations]) => {
      const {
        currency,
        currency_symbol: currencySymbol,
        id: siteId,
        phone_number: phoneNumber,
        cs_email: csEmail,
        mobile: is_mobile,
        sub_dir: subDirectory,
      } = site;
      const platform = is_mobile ? 'mobile' : 'desktop';
      const advert_id = get_boosts_element.dataset.boostsAdvertId;

      ReactDOM.render(
        <GetBoosts
          affiliateId={affiliate.id}
          boostProductDetails={productResults[0]}
          csEmail={csEmail}
          currency={currency.toLowerCase()}
          currencySymbol={currencySymbol}
          domainString={getDomainString(siteId)}
          offeredAdsCount={customer.adverts_offered}
          phoneNumber={phoneNumber}
          platform={platform}
          subDirectory={subDirectory}
          userId={customer.id}
          advertId={advert_id}
          localisations={localisations.upgrade}
        />,
        get_boosts_element,
      );
    });
  }
}
